import React from 'react';
import { useTranslation } from 'react-i18next';
import AddressForm from 'components/common/Forms/AddressForm/AddressForm';
import { Typography } from '@mui/material';
import { Helmet } from 'react-helmet';

const CreateAddress = (): JSX.Element => {
  const { t } = useTranslation('component');
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{t('MetaTag.AddAddressTitle')}</title>
        <meta name="description" content={t('MetaTag.AddAddressDescription').toString()} />
      </Helmet>
      <Typography variant="title">{t('AddressForm.CreateAddressTitle')}</Typography>
      <AddressForm />
    </>
  );
};

export default CreateAddress;
